import Api from '@/api/Api'
import store from '../store'

export default {

  async LoginLine (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('channel/authentication/line', data, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/ChannelAuthen.js